export const Experiments = {
  TrackingEvents: {
    donateButtonClick: 'donateButtonClick',
    shareModalOpen: 'shareModalOpen',
    shareSocialButtonClick: 'shareSocialButtonClick',
  },
  ConsumerFintech: {
    CheckoutConversion: {
      PopupSideBySideF22: {
        flagKey: 'consumerfintech_jgcheckout_conversion_pop-up_sbs_view_f22',
      },
    },
  },
};
